import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISystemSliceState } from './types';
import { ApiStatuses } from '../../app/types';
import {
  getStock
} from './api';

export const initialState: ISystemSliceState = {
  list: [],
  searchFilter: "",
  status: ApiStatuses.initial
};

export const fetchStock = createAsyncThunk(
  'system/fetchStock',
  async (query: { siteId: string, searchFilter: string }) => {
    const response = await getStock(query);
    return response.data;
  }
);


const slice = createSlice({
  name: "system",
  initialState,
  reducers: {
    setFilters(state: ISystemSliceState, action: PayloadAction<{ searchFilter: string }>) {
      state.searchFilter = action.payload.searchFilter;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchTenantStock
      .addCase(fetchStock.pending, (state) => {
        state.status = ApiStatuses.loading;
      })
      .addCase(fetchStock.fulfilled, (state, action) => {
        state.status = ApiStatuses.success;
        state.list = action.payload;
      })
      .addCase(fetchStock.rejected, (state) => {
        state.status = ApiStatuses.fail;
      })
  },
});

export const system = slice.reducer;
export const actions = slice.actions;